// Self-contained section behavior: no dependency on the System film runtime.
if (!customElements.get('bb-team-video')) {
  customElements.define('bb-team-video', class extends HTMLElement {
    connectedCallback() {
      if (this.dispose) return;
      const video = this.querySelector('video');
      if (!video) return;
      const lifetime = new AbortController();
      const motion = matchMedia('(prefers-reduced-motion: reduce)');
      const connection = navigator.connection;
      let visible = false;
      let pending = false;
      let blocked = false;
      let disposed = false;
      const on = (target, name, fn) => target?.addEventListener(name, fn, {signal: lifetime.signal});
      const wantsPlay = () => !disposed && visible && !document.hidden &&
        !motion.matches && !connection?.saveData && !blocked;
      const sync = () => {
        if (motion.matches || connection?.saveData) this.classList.remove('has-frame');
        if (!wantsPlay()) { video.pause(); return; }
        if (pending || !video.paused) return;
        if (!video.getAttribute('src')) video.src = video.dataset.src;
        video.muted = true;
        pending = true;
        video.play().then(() => {
          if (!wantsPlay()) video.pause();
        }).catch(() => { blocked = true; this.classList.remove('has-frame'); }).finally(() => {
          pending = false;
          if (wantsPlay() && video.paused) sync();
        });
      };
      video.muted = true;
      on(video, 'playing', () => {
        if (wantsPlay()) this.classList.add('has-frame');
        else video.pause();
      });
      on(video, 'error', () => {
        this.classList.remove('has-frame');
        blocked = true;
      });
      on(motion, 'change', sync);
      on(connection, 'change', sync);
      on(document, 'visibilitychange', sync);
      on(window, 'pagehide', () => video.pause());
      on(window, 'pageshow', sync);
      const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => {
        visible = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.1;
        sync();
      }, {threshold: [0, 0.1]}) : null;
      observer?.observe(this);
      this.dispose = () => {
        disposed = true;
        lifetime.abort();
        observer?.disconnect();
        video.pause();
        video.removeAttribute('src');
        video.load();
        this.classList.remove('has-frame');
      };
    }
    disconnectedCallback() { this.dispose?.(); this.dispose = null; }
  });
}
